export default "__VITE_ASSET__DJywb7mI__"